<script lang="ts" setup>
  import SubmenuItem from '~/components/layout/SubmenuItem.vue'
  import SubmenuEmptyState from '~/components/layout/SubmenuEmptyState.vue'
  import { isSubmenuVisible } from '~/composables/useSubmenu'
  import type { SubmenuItem as ISubmenuItem } from '~/types/submenu'

  const emit = defineEmits<{
    (e: 'childClick', item: ISubmenuItem): void
  }>()

  const submenuState = useSubmenu()
  // const interfaceStore = useInterfaceStore()

  const onChildClick = (child: ISubmenuItem): void => {
    emit('childClick', child)
  }
</script>

<template>
  <div class="h-full pr-1 shrink-0 min-w-0">
    <Transition
      enter-active-class="transition-all duration-500 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-all duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div v-if="isSubmenuVisible()" class="flex flex-col gap-2 py-6 px-1 text-content-title">
        <p class="font-medium text-xs+ px-2">{{ submenuState.title }}</p>
        <div class="flex flex-col gap-0.5">
          <SubmenuItem v-for="item in submenuState.items" :key="item.label" :item="item" />
        </div>
        <template v-for="item in submenuState.items" :key="item.label">
          <DeepDivider v-if="item.children" :dark-factor="0.1" :light-factor="0.1" class="my-1 px-2" color="#fbfbfb" />
          <div v-if="item.children" class="flex flex-col gap-2">
            <p class="font-medium text-xs text-[#9fa5aa] px-2 whitespace-nowrap">{{ $t(item.label) }}</p>
            <SubmenuEmptyState v-if="item.children.length === 0 && item.emptyState" :item="item" />
            <div v-else-if="item.children.length" class="flex flex-col gap-0.5">
              <SubmenuItem
                v-for="child in item.children"
                :key="child.label"
                :item="child"
                @click="onChildClick(child)"
              />
              <!-- <SubmenuQuickCreationInput v-if="item.isQuickCreationEnabled" :item="item" /> -->
            </div>
          </div>
        </template>
      </div>
    </Transition>
  </div>
</template>

<style>
  .submenu-item {
    @apply cursor-pointer flex items-center justify-between w-full p-2 hover:bg-silver-dark/10 rounded-lg border border-transparent transition-all duration-150 hover:shadow-sm whitespace-nowrap overflow-x-hidden;
  }

  .submenu-item.active {
    box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.1);
    @apply bg-silver-dark/10 border-silver-dark/20;
  }

  .submenu-item.disabled {
    @apply opacity-50 cursor-default;
  }
</style>
